import React from 'react';
import InvoicesFunctional from './components/invoices-functional';
import './invoices.scss';

const Invoices = () => {
	return <InvoicesFunctional />;
};

export default Invoices;
